import { useOptimizedProjectsQuery } from '../useOptimizedProjectsQuery';
import type { ProjectFiltersData } from '../useOptimizedProjectsQuery';

/**
 * Hook for fetching build projects (statuses: intake, tender, build, defects, archive)
 * Excludes: service (for maintenance) and inactive (discontinued) projects
 * Reuses existing optimized query with fixed build status filter
 */
export const useBuildProjectsQuery = (
  filters: Omit<ProjectFiltersData, 'status'>, 
  page: number = 1, 
  pageSize: number = 100
) => {
  // Fixed filter for build projects - exclude service and inactive
  const buildFilters: ProjectFiltersData = {
    ...filters,
    status: ['intake', 'tender', 'build', 'defects', 'archive']
  };

  return useOptimizedProjectsQuery(buildFilters, page, pageSize);
};
